/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCloudAccountTagSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCloudAccountTagSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCloudAccountTagSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCloudAccountTagSync>): BackgroundJobPayloadForPeriodicCloudAccountTagSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCloudAccountTagSync(), model);
        BackgroundJobPayloadForPeriodicCloudAccountTagSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCloudAccountTagSync>): BackgroundJobPayloadForPeriodicCloudAccountTagSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCloudAccountTagSync.newInstance(<BackgroundJobPayloadForPeriodicCloudAccountTagSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCloudAccountTagSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCloudAccountTagSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCloudAccountTagSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCloudAccountTagSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
